module.exports = __webpack_public_path__ + "img/hohlschnitt_karminrot_ral3002.02dc8567.jpg";